import React from 'react';

/**
 * AI Spinner.
 */
export function InlineSpinner() {
  const inlineStyle = `
  .osmosis-ai-loader {
    width: 3rem;
    height: .375rem;
    background-color: #ff8200;
    display: inline-block;
    box-sizing: border-box;
    animation: osmosis-ai-loading 1.6s ease-in-out infinite;
    animation-direction: alternate;
    left: calc(50% - 3.375rem);
    position: absolute;
    top: calc(50% - .5625rem);
  }

  @keyframes osmosis-ai-loading {
    0% {
        opacity: 0;
        transform: translate(1.875rem);
    }
    40% {
        opacity: .66;
        transform: translate(.625rem);
    }
    60% {
        opacity: .33;
        transform: translate(1.875rem);
    }
  }
`;
  return (
    <>
      <style>{inlineStyle}</style>
      <span className="osmosis-ai-loader" />
    </>
  );
}
